export const scrollToSidebarMenuItem = (id: string, behavior: ScrollBehavior = 'smooth'): void => {
  const itemNode: HTMLDivElement | null = document.querySelector(`#sidebar-scroll-container [data-id="${id}"]`);
  const sidebarNode: HTMLDivElement | null = document.querySelector(`#sidebar-scroll-container`);
  if (itemNode && sidebarNode) {
    const observer = new IntersectionObserver(
      ([item]) => {
        if (!item.isIntersecting) {
          const itemRect = itemNode.getBoundingClientRect();
          const element = document.querySelector('#sidebar-scroll-container');
          element?.scrollTo({
            top:
              sidebarNode.scrollTop + itemRect.y - (sidebarNode.getBoundingClientRect().height - itemRect.height) / 2,
            behavior,
          });
        }
        observer.disconnect();
      },
      {
        rootMargin: '0px 0px -10px 0px',
      }
    );
    observer.observe(itemNode);
  }
};
